import React from 'react';

import Authorization from '@modules/app/components/Authorization';
import {ButtonAdd} from '@modules/app/components/ButtonCollection';
import Link from '@modules/app/components/Link';
import {SPIIDEO_COMPETITOR_MAPPING} from '@constants/resources';
import {SECURITY_PRIVILEGES_CREATE_READ} from '@constants/variables';

const authorizationObject = {
    [SPIIDEO_COMPETITOR_MAPPING]: SECURITY_PRIVILEGES_CREATE_READ,
};

const SpiideoCompetitorMappingsIndexButtons = () => (
    <div className='content__buttons'>
        <Authorization authorization={authorizationObject}>
            <Link name='spiideoMappings.competitorAdd'>
                <ButtonAdd>Add new competitor mapping</ButtonAdd>
            </Link>
        </Authorization>
    </div>
);

SpiideoCompetitorMappingsIndexButtons.displayName = 'SpiideoCompetitorMappingsIndexButtons';

export default SpiideoCompetitorMappingsIndexButtons;
